import { useAuth0 } from '@auth0/auth0-react';
import { normalizeAuth0Props } from 'utils/authHelpers';

export const useAuth = () => {
  const auth0Props = useAuth0();
  return normalizeAuth0Props(auth0Props);
};
